var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconUpVote = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-205.52 -702.879) rotate(30)" },
                React.createElement("g", { transform: "translate(536 512)" },
                    React.createElement("path", { d: "M7.4-0.5l10.6,0c1.3,0,2.4,1.1,2.4,2.4l0,0c0,1.3-1.1,2.4-2.4,2.4l-10.6,0c-1.3,0-2.4-1.1-2.4-2.4l0,0\n\t\t\tC5.1,0.6,6.1-0.5,7.4-0.5z" }),
                    React.createElement("path", { d: "M7.4,0.8l10.6,0c0.6,0,1.1,0.5,1.1,1.1v0C19.1,2.5,18.6,3,18,3L7.4,3C6.8,3,6.3,2.5,6.3,1.9v0\n\t\t\tC6.3,1.3,6.8,0.8,7.4,0.8z" })),
                React.createElement("g", { transform: "translate(538 501)" },
                    React.createElement("path", { d: "M7.2-2.4l7.1,0c1,0,1.8,0.8,1.8,1.8l0,0c0,1-0.8,1.8-1.8,1.8l-7.1,0c-1,0-1.8-0.8-1.8-1.8l0,0\n\t\t\tC5.4-1.6,6.2-2.4,7.2-2.4z" }),
                    React.createElement("path", { d: "M7.2-1.1l7.1,0c0.3,0,0.5,0.2,0.5,0.5v0c0,0.3-0.2,0.5-0.5,0.5l-7.1,0c-0.3,0-0.5-0.2-0.5-0.5v0\n\t\t\tC6.7-0.9,6.9-1.1,7.2-1.1z" })),
                React.createElement("g", { transform: "translate(544 526) rotate(180)" },
                    React.createElement("path", { d: "M-4.7-2l1.8,10.6h-3.5L-4.7-2z" }),
                    React.createElement("path", { d: "M-4.7-2l1.8,10.6h-3.5L-4.7-2z" })),
                React.createElement("g", { transform: "translate(539 505)" },
                    React.createElement("path", { d: "M7.4-1.7l4.7,0l1.7,7.1l-8.2,0L7.4-1.7z" }),
                    React.createElement("path", { d: "M9.3,0.8l-0.5,2l1.7,0l-0.5-2L9.3,0.8 M7.4-1.7l4.7,0l1.7,7.1l-8.2,0L7.4-1.7z" }))))));
});
export default IconUpVote;
//# sourceMappingURL=IconUpVote.js.map